import { AxiosResponse } from 'axios'
import { privateApi } from 'api'
import { IMainPagePool, IUpdateMainPagePool } from 'models/mainPagePools'

export const mainPagePoolsApi = {
  getPools: (): Promise<AxiosResponse<IMainPagePool[]>> => {
    return privateApi.get('/admin/main-page-pools')
  },
  updatePool: (
    position: number,
    data: IUpdateMainPagePool
  ): Promise<AxiosResponse<IMainPagePool>> => {
    return privateApi.patch(`/admin/main-page-pools/${position}`, data)
  },
  // новый выключенный пул в конец
  createPool: (): Promise<AxiosResponse<IMainPagePool>> => {
    return privateApi.post('/admin/main-page-pools')
  },
  deletePool: (position: number) => {
    return privateApi.delete(`/admin/main-page-pools/${position}`)
  }
}
